var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-action-dialog',{attrs:{"value":_vm.value,"onSave":_vm.onSave,"confirmText":"Löschen","denyText":"Abbrechen"},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_c('template',{slot:"title"},[_vm._v(" Organisation löschen ")]),[_vm._v(" Möchten Sie die Organisation '"+_vm._s(_vm.name)+"' wirklich löschen? ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }